import React, { useState, useContext, useEffect } from "react";
import PreferenceSwitcher from "../../component/PreferenceSwitcher";
import "antd/dist/reset.css";
import { IconAlignRight, IconBell } from "@tabler/icons-react";
import { Badge, Button } from "antd";
import { useNavigate } from "react-router-dom";
import "../../css/topNav.css";
import GlobalProfileMenu from "../../util/GlobalProfileMenu";
import handleLogout from "../../util/logout";
import { useGlobalAuthModal } from "../../util/GlobalAuthModal";
import { usePreference } from "../../context/PreferenceContext";
import NotificationServ from "../../service/NotificationServ";
import UserServ from "../../service/UserServ";
import near from "../../assets/img/near.jpg";



const TopNavSuperAdmin = ({ onToggle }) => {
  const { t } = usePreference();
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  const { showAlert } = useGlobalAuthModal();
  const [unreadCount, setUnreadCount] = useState(0);
  const [stats, setStats] = useState(null);

  const fetchUnreadCount = async () => {
    try {
      const res = await NotificationServ.getUnreadCount();
      if (res && res.data !== undefined) {
        setUnreadCount(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch unread count", error);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await UserServ.getBuyerStats();
      if (res && res.data) {
        setStats(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch admin stats", error);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    fetchStats();

    window.addEventListener("notification-refresh", fetchUnreadCount);
    window.addEventListener("profile-updated", fetchStats);

    return () => {
      window.removeEventListener("notification-refresh", fetchUnreadCount);
      window.removeEventListener("profile-updated", fetchStats);
    };
  }, []);



  // Logout - use centralized function
  const handleLogOut = () => {
    showAlert({
      title: t('logout_title'),
      description: t('logout_description'),
      buttons: [
        { text: t('stay_here'), variant: 'default' },
        {
          text: t('sign_out'),
          variant: 'primary',
          onClick: () => {
            handleLogout();
          }
        }
      ]
    });
  };
  return (
    <div className={`topnav ${darkMode ? "dark" : "light"}`}>
      <div className="topnav-left">
        <button onClick={onToggle} className="menu-btn">
          <IconAlignRight size={22} />
        </button>
        <img
          src={near}
          alt="Nearzon"
          className="logo-img"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer", marginLeft: "10px" }}
        />
      </div>

      <div className="topnav-right">
        <div className="desktop-only-flex" style={{ display: 'flex', alignItems: 'center', gap: '16px', marginRight: 20 }}>
          <Badge count={unreadCount} overflowCount={99} size="small">
            <Button
              type="text"
              icon={<IconBell size={22} />}
              onClick={() => navigate("/admin/notifications")}
              className="notification-btn"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            />
          </Badge>
          <PreferenceSwitcher mode="light" />
        </div>
        <GlobalProfileMenu handleLogOut={handleLogOut} stats={stats} />
      </div>
    </div>
  );
};

export default TopNavSuperAdmin;
